import Polyglot from 'node-polyglot';
import { messageFormat } from '@clubmed/utils';
const polyglot = new Polyglot({
  allowMissing: true,
  interpolation: {
    prefix: '{',
    suffix: '}',
  },
  onMissingKey: (key, options) => {
    // Handle plurals the way it's formatted in the CMS:
    // {
    //    n: '{count} kids',
    //    _0: '0 kids'
    //    _1: '1 kid'
    //    _2: '{count} kids '
    //    ...
    //    _10: '10 kids and more'
    // }
    // We assume we can only have up to 11 variations (0 to 10).
    const MAX_PLURAL_VARIATIONS = 11;
    const pluralsObject = new Array(MAX_PLURAL_VARIATIONS).fill('').reduce(
      (acc, _, index) => {
        return {
          ...acc,
          // Polyglot cannot return an object of variations, so we have to test each one.
          ...(polyglot.has(`${key}._${index}`) && {
            [`_${index}`]: polyglot.t(`${key}._${index}`),
          }),
        };
      },
      polyglot.has(`${key}.n`)
        ? {
            n: polyglot.t(`${key}.n`),
          }
        : {},
    );

    if (Object.keys(pluralsObject).length > 0) {
      return messageFormat(pluralsObject).format(options);
    }

    // If no plural form, return key.
    return key;
  },
});
export function t(
  key: string,
  variables?: Record<string, string | number>,
  defaultValue?: string,
): string {
  const value = polyglot.t(key, variables);
  return value === key && typeof defaultValue !== 'undefined' ? defaultValue : value;
}
export const getListValue = (key: string, limit: number = 10) => {
  const keys = new Array(limit)
    .fill('')
    .map((_, i) => (polyglot.has(`${key}.${i}`) ? t(`${key}.${i}`) : _))
    .filter(Boolean);
  return keys;
};
export function has(key: string) {
  return polyglot.has(key);
}
export function setLocale(locale: string) {
  return polyglot.locale(locale);
}
export function addTranslationKeys(keys: any) {
  return polyglot.extend(keys);
}
export function getAll() {
  return polyglot.phrases;
}
export function getKeyValue(key: string) {
  return polyglot.phrases[key];
}
export function clearAll() {
  return polyglot.clear();
}
